<div class="table-responsive" [class.overflow-hidden]="parcelsService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover parcel-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': parcelsService.data.allParcels.data.length < 2}">
                <th></th>
                <th></th>
                <th *ngIf="parcelsService.buildings.length != 1 && !authenticationService.userIsResident"
                    (click)="orderBy('building.name', $event)">
                    Building <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!authenticationService.userIsResident" (click)="orderBy('suite.suiteNumber', $event)">
                    Unit <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('parcelNumber', $event)">
                    ID <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('parcelType.name', $event)">
                    Type <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('barCode', $event)">
                    Barcode <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('resident.fullName', $event)">
                    Resident <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">
                    Received <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('numberPieces', $event)">
                    # of Pieces
                    <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('status', $event)">
                    Status <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('pickedUpAt', $event)" *ngIf="!onlyReceivedFilterChecked()">
                    Picked Up <span *ngIf="!authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!authenticationService.userIsResident">Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="parcelsService.data.allParcels.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.showDetailedView">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>
                        <span *ngIf="item.isIncomingParcel()" title="Incoming">Incoming</span>
                        <span *ngIf="item.isOutgoingParcel()" title="Outgoing">Outgoing</span>
                    </td>
                    <td *ngIf="parcelsService.buildings.length != 1 && !authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Building</span>
                        </div>
                        <span>{{item.buildingName}}</span>
                    </td>
                    <td *ngIf="!authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Unit</span>
                        </div>
                        <span>{{item.suiteNumber}}</span>
                    </td>
                    <td class="parcels-hint-td">
                        <div class="table-mobile-left">
                            <span>ID</span>
                        </div>
                        <span>{{item.parcelNumber}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Type</span>
                        </div>
                        <span>{{item.parcelTypeName}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Barcode</span>
                        </div>
                        <span>{{item.barCode}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Resident</span>
                        </div>

                        <span>{{item.residentFullName}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Received</span>
                        </div>
                        <span>{{item.createdAt | mccDate:false:true}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span># of Pieces</span>
                        </div>
                        <span>{{item.numberPieces}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Status</span>
                        </div>
                        <div class="table-mobile-right">
                            <span *ngIf="item.status === 'picked_up'" class="text-uppercase label label-picked_up">
                                picked up
                            </span>
                            <span *ngIf="item.status !== 'picked_up'" class="text-uppercase label label-{{item.status}}">
                                {{item.status}}
                            </span>
                        </div>
                    </td>
                    <td *ngIf="!onlyReceivedFilterChecked()">
                        <div class="table-mobile-left">
                            <span>Picked Up</span>
                        </div>
                        <span>{{item.pickedUpAt | mccDate:false:true}}</span>
                    </td>
                    <td *ngIf="!authenticationService.userIsResident" class="td-action-btn">
                        <div class="input-group" (click)="$event.showDropdown = true;">
                            <div *ngIf="item.status === 'received' && item.isCanEdit" class="input-group-btn btn-in-table">
                                <button (click)="parcelsService.showTransitModal(item, 'pick_up')" class="btn btn-white btn-xs">
                                    Mark Pick Up
                                </button>
                                <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs" aria-expanded="false">
                                    <span class="caret"></span>
                                </button>
                                <ul class="dropdown-menu pull-right">
                                    <li (click)="parcelsService.editParcel(item)">
                                        <a>Edit</a>
                                    </li>
                                    <li *ngIf="item.isIncomingParcel()" (click)="parcelsService.showTransitModal(item, 'return')">
                                        <a>Return</a>
                                    </li>
                                    <li *ngIf="item.isOutgoingParcel()" (click)="parcelsService.showTransitModal(item, 'cancel')">
                                        <a>Cancel</a>
                                    </li>
                                    <li *ngIf="item.isCanDelete" (click)="parcelsService.remove(item.id)">
                                        <a>Delete</a>
                                    </li>
                                    <li *ngIf="receiverHasEmailOrPhone(item)" (click)="parcelsService.sendReminder(item)">
                                        <a>Send Reminder</a>
                                    </li>
                                    <li (click)="parcelsService.printParcel(item)">
                                        <a>Print</a>
                                    </li>
                                </ul>
                            </div>
                            <div *ngIf="item.status !== 'received' || !item.isCanEdit" class="input-group-btn btn-in-table">
                                <button (click)="parcelsService.printParcel(item)" class="btn btn-white btn-xs">
                                    Print
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of parcelsService.emptyRowService.emptyRow" class="empty-row" style="cursor: default;">
                <td></td>
                <td>&nbsp;</td>
                <td *ngIf="parcelsService.buildings.length != 1"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="!onlyReceivedFilterChecked()"></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!parcelsService.data.allParcels.total"
                          [isServiceUnavailable]="parcelsService.showServiceUnavailable"
                          [isLoading]="parcelsService.spinnerShow">
        You have no parcels listed on the system<br>
        <span *ngIf="parcelsService.account.canUpdate(parcelsService.serviceName)">
            <a href="javascript://" (click)="parcelsService.isParcelModalShow = true" class="mtv-primary-color clickable-text">add a parcel</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcels-list/parcels-list.component.html